import { loadCss, loadModules, setDefaultOptions } from "esri-loader";
import { Utils } from "./Utils";
import BubbleLayer from "./widgets/Animation/BubbleLayer";
import DiamondLayer from "./widgets/Animation/DiamondLayer";
import RippleLayer from "./widgets/Animation/RippleLayer";
import WallLayer from "./widgets/Animation/WallLayer";
import { CameraPosition } from "./widgets/CameraPosition/arcgis/CameraPosition";
import { Cluster } from "./widgets/Cluster/arcgis/Cluster";
import CrossRegion from "./widgets/CrossRegion/CrossRegion";
import { DrawLayer } from "./widgets/DrawLayer/arcgis/DrawLayer";
import DynamicIssuesect from "./widgets/DynamicIssuesect";
// import { RasterStretchRenderer } from "esri/rasterRenderers";
import { FindFeature } from "./widgets/FindFeature/arcgis/FindFeature";
import { GeometrySearch } from "./widgets/GeometrySearch/arcgis/GeometrySearch";
// import { HeatImage } from "./widgets/HeatMap/arcgis/HeatImage";
// import HeatImage2D from "./widgets/HeatMap/arcgis/HeatImage2D";
// import HeatImageGL from "./widgets/HeatMap/arcgis/HeatImageGL";
import HeatImage3D from "./widgets/HeatMap/arcgis/HeatImage3D";
// import { HeatMap } from "./widgets/HeatMap/arcgis/HeatMap";
import { HeatMap3D } from "./widgets/HeatMap/arcgis/HeatMap3D";
import { checkPoints } from "./widgets/MapCenterCheck/arcgis/CheckPoints";
import MapCenterCheck from "./widgets/MapCenterCheck/arcgis/MapCenterCheck";
import PassagewayWall from "./widgets/MapCenterCheck/arcgis/PassagewayWall";
import { Bar3DChart } from "./widgets/MigrateChart/arcgis/Bar3DChart";
import { FlowLine } from "./widgets/MigrateChart/arcgis/FlowLine";
import { MigrateChart } from "./widgets/MigrateChart/arcgis/MigrateChart";
import { ComponentOverlay } from "./widgets/Overlays/arcgis/ComponentOverlay";
import { OverlayArcgis2D } from "./widgets/Overlays/arcgis/OverlayArcgis2D";
import ToolTip from "./widgets/Overlays/arcgis/ToolTip";
import SelectLane from "./widgets/SelectLane";
import SignalPhaseController2D from "./widgets/SignalPhase/2D/SignalPhaseController2D";
import SignalPhaseController from "./widgets/SignalPhase/SignalPhaseController";
import SimulationController from "./widgets/SumoSimulation/SimulationController";
import TrackPlay3D from "./widgets/TrackPlay/arcgis/TrackPlay3D";
import { OverlayArcgis3D } from "@/plugin/gis-viewer/widgets/Overlays/arcgis/OverlayArcgis3D";
import {
  ICamera,
  ICenterLevel,
  IComponentOverlayParam,
  ICrossCamera,
  ICrossInView,
  ICrossRegionInfo,
  ICustomTip,
  IDefinitionParameter,
  IDistrictParameter,
  IDrawOverlays,
  IDynamicLayerDataParams,
  IFindParameter,
  IGeometrySearchParameter,
  IHeatImageParameter,
  IHeatParameter,
  ILaneSignalPhaseInfo,
  ILayerConfig,
  IMapContainer,
  IMapLevel,
  IOverlayClusterParameter,
  IOverlayDelete,
  IOverlayParameter,
  IPassagewaysParam,
  IPointGeometry,
  IPopUpTemplate,
  IResult,
  ISelectRouteHitTest,
  ISelectRouteParam,
  ISelectRouteResult,
  IShowSelectedLaneParam,
  ISignalPhaseInfo,
  IStreetParameter,
  ISumoConnectInfo,
  ITrackParameter,
  IRouteParameter,
} from "@/types/map";

export default class MapAppArcGIS3D implements IMapContainer {
  public view!: __esri.SceneView;
  public showGisDeviceInfo: any;
  public layerLoaded: any;
  private mapToolTip: any;
  public mapClick: any;
  private showFlow: boolean = false;
  public mouseoverlay: any = undefined;
  private toolTip!: any;
  private clickPopup!: {
    label: string;
    popup: any;
    graphic: any;
    mapPoint: any;
  };
  public mouseGisDeviceInfo!: (
    event: any,
    type: string,
    id: string,
    detail: any
  ) => void;
  private Point!: __esri.PointConstructor;
  private Graphic!: __esri.GraphicConstructor;
  private webMercatorUtils!: __esri.webMercatorUtils;
  private geometryEngine!: __esri.geometryEngine;

  public mapFocused!: (
    focusInfo: { type: string; id: string } | undefined
  ) => void;

  public mapInteractive!: (viewPoint: __esri.Viewpoint) => void;

  public requestNextSignalPhase!: (crossId: string) => void;
  public phaseChanged!: (crossId: string, phase: string) => void;
  public crossInfoPanelInfos?: Array<{
    id: string;
    position: number[];
    positionCoor: number[];
    videoUrl: string;
  }>;

  public async initialize(gisConfig: any, mapContainer: string): Promise<void> {
    let mapConfig = Utils.copyObject(gisConfig);
    const apiUrl =
      mapConfig.arcgis_api || mapConfig.apiUrl || "https://js.arcgis.com/4.18/";
    const gisServer = mapConfig.gisServer;

    setDefaultOptions({ url: `${apiUrl}/init.js` });

    const cssFile: string = mapConfig.theme
      ? `themes/${mapConfig.theme}/main.css`
      : "css/main.css";
    loadCss(`${apiUrl}/esri/${cssFile}`);
    if (mapConfig.theme == "custom") {
      const customcssFile: string = mapConfig.theme
        ? `themes/${mapConfig.theme}/custom.css`
        : "";
      if (customcssFile !== "") {
        loadCss(`${apiUrl}/esri/${customcssFile}`);
      }
    }
    type MapModules = [
      typeof import("esri/views/SceneView"),
      typeof import("esri/Basemap"),
      typeof import("esri/Map"),
      typeof import("esri/Graphic"),
      typeof import("esri/layers/TileLayer"),
      typeof import("esri/layers/WebTileLayer"),
      typeof import("esri/core/Collection"),
      typeof import("esri/WebScene"),
      typeof import("esri/geometry/support/webMercatorUtils"),
      typeof import("esri/geometry/Point"),
      typeof import("esri/geometry/geometryEngine")
    ];
    const [
      SceneView,
      Basemap,
      Map,
      Graphic,
      TileLayer,
      WebTileLayer,
      Collection,
      WebScene,
      webMercatorUtils,
      Point,
      geometryEngine,
    ] = await (loadModules([
      "esri/views/SceneView",
      "esri/Basemap",
      "esri/Map",
      "esri/Graphic",
      "esri/layers/TileLayer",
      "esri/layers/WebTileLayer",
      "esri/core/Collection",
      "esri/WebScene",
      "esri/geometry/support/webMercatorUtils",
      "esri/geometry/Point",
      "esri/geometry/geometryEngine",
    ]) as Promise<MapModules>);

    this.Point = Point;
    this.Graphic = Graphic;
    this.webMercatorUtils = webMercatorUtils;
    this.geometryEngine = geometryEngine;

    let map: __esri.Map | __esri.WebScene;

    const baseLayers: __esri.Collection = new Collection();
    if (mapConfig.baseLayers) {
      baseLayers.addMany(
        mapConfig.baseLayers.map((layerConfig: ILayerConfig) => {
          if (layerConfig.url) {
            layerConfig.url = layerConfig.url.replace(
              /{gisserver}/i,
              gisServer
            );
          }
          if (layerConfig.type === "tiled") {
            delete layerConfig.type;
            return new TileLayer(layerConfig);
          } else if (layerConfig.type === "webtiled") {
            return new WebTileLayer({
              urlTemplate: layerConfig.url,
              subDomains: layerConfig.subDomains || undefined,
            });
          }
        })
      );
    }
    const basemap: __esri.Basemap = new Basemap({
      baseLayers,
    });

    if (mapConfig.webScene) {
      map = new WebScene({ ...mapConfig.webScene, basemap });
    } else {
      map = new Map({
        basemap,
        ground: mapConfig.options.ground,
      });
    }

    const view: __esri.SceneView = new SceneView({
      map,
      container: mapContainer,
      ...mapConfig.options,
    });
    if (mapConfig.options.noUI) {
      view.ui.remove(["navigation-toggle", "compass", "zoom"]);
    }
    if (mapConfig.operationallayers) {
      await this.createLayer(view, mapConfig.operationallayers, gisServer);
    }

    (view as any).mapConfig = mapConfig;
    (view as any).mapOptions = mapConfig.options;

    view.ui.remove("attribution");
    // view.ui.remove("zoom");
    // view.ui.remove("compass");
    // view.ui.remove("navigation-toggle");
    view.popup.watch("visible", async (newValue) => {
      view.popup.alignment = "top-center";
      if (newValue) {
        let content = view.popup.content;
        if (view.popup.selectedFeature) {
          //feature
          var attributes = view.popup.selectedFeature.attributes;
          var newAttr: any = new Object();
          for (let field in attributes) {
            let fieldArr: string[] = field.toString().split(".");
            let newfield = fieldArr.pop() as string;
            if (!attributes.hasOwnProperty(newfield)) {
              attributes[newfield] =
                attributes[field] !== undefined && attributes[field] !== null
                  ? attributes[field].toString().replace("Null", "")
                  : "";
            }
          }
        } else {
          //dynamic
          if (
            typeof content === "string" &&
            content.toString().indexOf("Null") > -1
          ) {
            content = content.toString().replace(/Null/g, "");
            view.popup.content = content;
          }
        }
        if (content == "Null" || content == "" || content == null) {
          view.popup.close();
        }
      }
    });
    let _this = this;
    view.on(["pointer-move"], async (event: any) => {
      const response = await view.hitTest(event);
      if (response.results.length > 0) {
        let result = response.results[0];

        const graphic = result.graphic;
        if (!graphic.attributes) {
          graphic.attributes = {};
        }
        let { type, id } = graphic.attributes;
        let label = graphic.layer ? (graphic.layer as any).label : "";
        if (
          graphic.layer &&
          (graphic.layer.type == "feature" || graphic.layer.type == "graphics")
        ) {
          id =
            graphic.attributes["DEVICEID"] ||
            graphic.attributes["FEATUREID"] ||
            graphic.attributes["SECTIONID"] ||
            graphic.attributes["id"] ||
            graphic.attributes["ID"] ||
            undefined;
          type =
            graphic.attributes["DEVICETYPE"] ||
            graphic.attributes["FEATURETYPE"] ||
            graphic.attributes["FEATURETYP"] ||
            graphic.attributes["type"] ||
            graphic.attributes["TYPE"] ||
            label ||
            undefined;
        }
        //if (id) {
        if (
          graphic.attributes &&
          (graphic.attributes.isCluster || graphic.attributes.isClusterText)
        ) {
          return;
        }
        if ((graphic.layer as any).toolTipContent) {
          this.moveToolTip(
            graphic,
            (graphic.layer as any).toolTipContent.content
          );
        }
        if (!this.mouseoverlay) {
          event.type = "mouseover";
          this.mouseGisDeviceInfo(event, type, id, graphic.toJSON());
          this.mouseoverlay = {
            event,
            type,
            id,
            graphic: graphic.toJSON(),
          };
        } else {
          if (
            this.mouseoverlay &&
            this.mouseoverlay.id !== id &&
            this.mouseoverlay.type !== type
          ) {
            if (this.toolTip) {
              this.toolTip.remove();
              this.toolTip = null;
            }
            event.type = "mouseout";
            this.mouseGisDeviceInfo(
              event,
              this.mouseoverlay.type,
              this.mouseoverlay.id,
              this.mouseoverlay.graphic
            );
            this.mouseoverlay = undefined;
          }
        }
      } else {
        if (this.mouseoverlay) {
          if (this.toolTip) {
            this.toolTip.remove();
            this.toolTip = null;
          }
          event.type = "mouseout";
          this.mouseGisDeviceInfo(
            event,
            this.mouseoverlay.type,
            this.mouseoverlay.id,
            this.mouseoverlay.graphic
          );
          this.mouseoverlay = undefined;
        }
      }
    });
    view.on("click", async (event) => {
      console.log(this.view.camera.clone());
      // console.log(this.view.center, this.view.zoom);
      if (event.mapPoint) {
        let mp = event.mapPoint;
        if (
          !mp.spatialReference.isWGS84 &&
          !mp.spatialReference.isWebMercator
        ) {
          //城建坐标
          this.mapClick({
            x: mp.x,
            y: mp.y,
            lnt: mp.longitude,
            lat: mp.latitude,
            wkid: mp.spatialReference.wkid,
          });
        } else {
          this.mapClick({
            x: mp.longitude,
            y: mp.latitude,
            lnt: mp.longitude,
            lat: mp.latitude,
            realx: mp.x,
            realy: mp.y,
            wkid: mp.spatialReference.wkid,
          });
        }
      } else {
        _this.mapClick(event);
      }

      const response = await view.hitTest(event);
      if (response.results.length > 0) {
        // response.results.forEach((result) => {
        //   //}
        // });
        let result = response.results[0];
        const graphic = result.graphic;
        if (graphic.attributes) {
          let { type, id } = graphic.attributes;
          let label = graphic.layer ? (graphic.layer as any).label : "";
          if (
            graphic.layer &&
            (graphic.layer.type == "feature" ||
              graphic.layer.type == "graphics")
          ) {
            id =
              graphic.attributes["DEVICEID"] ||
              graphic.attributes["FEATUREID"] ||
              graphic.attributes["SECTIONID"] ||
              graphic.attributes["id"] ||
              graphic.attributes["ID"] ||
              undefined;
            type =
              graphic.attributes["DEVICETYPE"] ||
              graphic.attributes["FEATURETYPE"] ||
              graphic.attributes["FEATURETYP"] ||
              graphic.attributes["type"] ||
              graphic.attributes["TYPE"] ||
              label ||
              undefined;
          }
          if (
            graphic.attributes &&
            (graphic.attributes.isCluster || graphic.attributes.isClusterText)
          ) {
            label = "cluster";
          }
          let detailData = graphic.clone();
          if (graphic.geometry.spatialReference.isWebMercator) {
            detailData.geometry = webMercatorUtils.webMercatorToGeographic(
              graphic.geometry
            );
          }
          detailData = detailData.toJSON();

          (detailData as any).mapPoint = event.mapPoint;
          (detailData as any).screenPoint = event.screenPoint;

          this.clickPopup = {
            label: label,
            popup: graphic.layer
              ? (graphic.layer as any).popupTemplate
              : undefined,
            graphic: graphic,
            mapPoint: event.mapPoint,
          };
          this.showGisDeviceInfo(type, id, detailData, label);
        }
      } else {
        this.doIdentifyTask(event.mapPoint).then((results: any) => {
          if (results.length > 0) {
            let res = results.filter((item: any) => {
              if (item != undefined) {
                return true;
              } else {
                return false;
              }
            })[0];
            if (!res) {
              return;
            }
            let layername = res.layerName;
            let layerid = res.layerId;
            let id =
              res.feature.attributes["DEVICEID"] ||
              res.feature.attributes["FEATUREID"] ||
              res.feature.attributes["SECTIONID"] ||
              res.feature.attributes[res.displayFieldName];
            this.highlightFeature(res.feature.geometry);
            let selectLayer = this.getLayerByName(layername, layerid);
            if (selectLayer.popupTemplates) {
              let popup = selectLayer.popupTemplates[layerid];
              this.clickPopup = {
                label: layername,
                popup: popup,
                graphic: res.feature,
                mapPoint: event.mapPoint,
              };
              if (
                popup &&
                selectLayer.popupEnabled !== false &&
                typeof popup.content === "string"
              ) {
                this.view.popup.open({
                  title: popup.title,
                  content: this.getContent(
                    res.feature.attributes,
                    popup.content
                  ),
                  location: event.mapPoint,
                });
              }
            }
            res.feature.attributes.mapPoint = event.mapPoint;
            res.feature.attributes.screenPoint = event.screenPoint;
            this.showGisDeviceInfo(
              layername,
              id,
              res.feature.attributes,
              selectLayer.label
            );
          } else {
            //ToolTip.clear(this.view, undefined);
          }
        });
      }
    });
    view.popup.on("trigger-action", (event) => {
      const graphic = view.popup.selectedFeature;
      if (event.action.id === "sumo-details") {
        this.showGisDeviceInfo(
          "sumo-details",
          graphic.attributes["id"],
          graphic
        );
      }
    });
    await view.when();

    if (mapConfig.viewAnimation) {
      for (let i = 0; i < mapConfig.viewAnimation.length; i++) {
        const animation = mapConfig.viewAnimation[i];
        await view.goTo(animation.target, animation.option);
      }
    }
    this.view = view;
    if (this.showFlow) {
      this.showFlowLine();
    }
    // let fly = FlyLineRender.getInstance(view);
    // fly.startup();

    // let pt = RipplePoint.getInstance(view);
    // pt.startup();
  }
  private destroy() {}
  private async moveToolTip(graphic: any, content: string) {
    if (this.toolTip) {
      this.toolTip.remove();
      this.toolTip = null;
    }
    this.toolTip = new ToolTip(
      this.view,
      {
        title: "",
        istip: true,
        yoffset: 40,
        content: this.getContent(graphic.attributes, content),
      },
      graphic
    );
  }

  //使toolTip中支持{字段}的形式
  private getContent(attr: any, content: string): string {
    let tipContent = content;
    //console.log(tipContent);
    if (tipContent) {
      //键值对
      for (let fieldName in attr) {
        if (attr.hasOwnProperty(fieldName)) {
          tipContent = tipContent.replace(
            "{" + fieldName + "}",
            attr[fieldName]
          );
        }
      }
    }
    let reg = /\{.*?\}/g;
    let id = attr.id || "";
    tipContent = tipContent.replace(reg, "");
    return tipContent;
  }
  private getLayerIds(layer: any): any[] {
    let layerids = [];
    if (layer.type == "feature") {
      //featurelayer查询
      layerids.push(layer.layerId);
    } else if (layer.type == "map-image") {
      let sublayers = (layer as __esri.MapImageLayer).sublayers;
      sublayers.forEach((sublayer) => {
        if (sublayer.visible) {
          layerids.push(sublayer.id);
        }
      });
    }
    return layerids.reverse();
  }
  private getLayerByName(layername: string, id: string | number): any {
    let selLayer;
    let layers = this.view.map.allLayers.toArray().forEach((layer: any) => {
      if (layer.type == "imagery" || layer.type == "map-image") {
        let sublayers = (layer as __esri.MapImageLayer).allSublayers;
        sublayers.forEach((sublayer) => {
          if (
            sublayer.title == layername &&
            sublayer.id.toString() == id.toString()
          ) {
            selLayer = layer;
          }
        });
      }
      return false;
    });
    return selLayer;
  }
  private async doIdentifyTask(clickpoint: any) {
    let layers = this.view.map.allLayers.filter((layer: any) => {
      if (
        layer.visible &&
        (layer.type == "imagery" || layer.type == "map-image")
      ) {
        return true;
      }
      return false;
    });
    let that = this;
    type MapModules = [
      typeof import("esri/Graphic"),
      typeof import("esri/tasks/IdentifyTask"),
      typeof import("esri/tasks/support/IdentifyParameters")
    ];
    const [Graphic, IdentifyTask, IdentifyParameters] = await (loadModules([
      "esri/Graphic",
      "esri/tasks/IdentifyTask",
      "esri/tasks/support/IdentifyParameters",
    ]) as Promise<MapModules>);
    let promises: any = layers.toArray().map((layer: any) => {
      return new Promise((resolve, reject) => {
        let identify = new IdentifyTask(layer.url); //创建属性查询对象

        let identifyParams = new IdentifyParameters(); //创建属性查询参数
        identifyParams.tolerance = 3;
        identifyParams.layerIds = that.getLayerIds(layer);
        identifyParams.layerOption = "visible"; //"top"|"visible"|"all"
        identifyParams.width = that.view.width;
        identifyParams.height = that.view.height;
        identifyParams.geometry = clickpoint;
        identifyParams.returnGeometry = true;
        identifyParams.mapExtent = that.view.extent;

        // 执行查询对象
        identify.execute(identifyParams).then((data: any) => {
          let results = data.results;
          if (results.length < 1) {
            resolve(undefined);
          } else {
            resolve(results[0]);
          }
        });
      });
    });
    return new Promise((resolve) => {
      Promise.all(promises).then((e: any) => {
        resolve(e);
      });
    });
  }

  private async createLayer(
    view: __esri.SceneView,
    layers: any,
    gisServer: string
  ) {
    type MapModules = [
      typeof import("esri/layers/FeatureLayer"),
      typeof import("esri/layers/WebTileLayer"),
      typeof import("esri/layers/MapImageLayer"),
      typeof import("esri/layers/GeoJSONLayer"),
      typeof import("esri/layers/WMSLayer"),
      typeof import("esri/layers/SceneLayer"),
      typeof import("esri/layers/VectorTileLayer"),
      typeof import("esri/layers/TileLayer")
      // typeof import("esri/layers/support/LabelClass"),
      // typeof import("esri/Color"),
      // typeof import("esri/symbols/Font"),
      // typeof import("esri/symbols/TextSymbol"),
    ];
    const [
      FeatureLayer,
      WebTileLayer,
      MapImageLayer,
      GeoJSONLayer,
      WMSLayer,
      SceneLayer,
      VectorTileLayer,
      TileLayer,
      // Layer,
      // LabelClass,
      // Color,
      // Font,
      // TextSymbol,
    ] = await (loadModules([
      "esri/layers/FeatureLayer",
      "esri/layers/WebTileLayer",
      "esri/layers/MapImageLayer",
      "esri/layers/GeoJSONLayer",
      "esri/layers/WMSLayer",
      "esri/layers/SceneLayer",
      "esri/layers/VectorTileLayer",
      "esri/layers/TileLayer",
      // "esri/layers/Layer",
      // "esri/layers/support/LabelClass",
      // "esri/Color",
      // "esri/symbols/Font",
      // "esri/symbols/TextSymbol",
    ]) as Promise<MapModules>);
    let map = view.map;
    let _this = this;
    map.addMany(
      layers
        .map((layerConfig: any) => {
          let layer: any;
          let type = layerConfig.type.toLowerCase();
          if (layerConfig.url) {
            layerConfig.url = layerConfig.url.replace(
              /{gisserver}/i,
              gisServer
            );
          }
          delete layerConfig.type;
          switch (type) {
            case "feature":
              if ((layerConfig as any).showFlow) {
                _this.showFlow = true;
              }
              layer = new FeatureLayer(layerConfig);
              layer.labelingInfo = layerConfig.labelingInfo;
              break;
            case "dynamic":
              if ((layerConfig as any).showFlow) {
                _this.showFlow = true;
              }
              layer = new MapImageLayer(layerConfig);
              break;
            case "wms":
              layer = new WMSLayer(layerConfig);
              break;
            case "geojson":
              layer = new GeoJSONLayer(layerConfig);
              break;
            case "tiled":
              layer = new TileLayer(layerConfig);
              break;
            case "webtiled":
              layer = new WebTileLayer({
                urlTemplate: layerConfig.url,
                subDomains: layerConfig.subDomains || undefined,
              });
              break;
            case "json":
              const drawlayer = DrawLayer.getInstance(view);
              drawlayer.addDrawLayer(layerConfig);
              break;
            case "image":
              // const heat = ImageOverlays.getInstance(view);
              // heat.addCanvasImage(layerConfig);
              break;
            case "scene":
              layer = new SceneLayer(layerConfig);
              break;
            case "vectortile":
              layer = new VectorTileLayer(layerConfig);
              break;
          }
          // if (layer) {
          //   layer.id = layerConfig.id || layerConfig.label;
          // }
          return layer;
        })
        .filter((layer: any) => {
          return layer !== undefined;
        })
    );
  }
  public async showFlowLine() {
    const flow = FlowLine.getInstance(this.view);
    flow.showFlowLine();
  }
  public async addOverlays(params: IOverlayParameter): Promise<IResult> {
    const overlay = OverlayArcgis3D.getInstance(this.view);
    return await overlay.addOverlays(params);
  }
  public async getOverlays(params: IOverlayDelete): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async addOverlaysCluster(
    params: IOverlayClusterParameter
  ): Promise<IResult> {
    const cluster = Cluster.getInstance(this.view);
    return await cluster.addOverlaysCluster(params);
  }
  public async addHeatMap(params: IHeatParameter) {
    const heatmap = HeatMap3D.getInstance(this.view);
    return await heatmap.addHeatMap(params);
  }
  public async deleteAllOverlays() {
    const overlay = OverlayArcgis3D.getInstance(this.view);
    return await overlay.deleteAllOverlays();
  }
  public async deleteAllOverlaysCluster() {
    const cluster = Cluster.getInstance(this.view);
    return await cluster.deleteAllOverlaysCluster();
  }
  public async deleteHeatMap(params: ILayerConfig) {
    const heatmap = HeatMap3D.getInstance(this.view);
    return await heatmap.deleteHeatMap();
  }
  public async deleteOverlays(params: IOverlayDelete): Promise<IResult> {
    const overlay = OverlayArcgis3D.getInstance(this.view);
    return await overlay.deleteOverlays(params);
  }
  public async deleteOverlaysCluster(params: IOverlayDelete) {
    const cluster = Cluster.getInstance(this.view);
    return await cluster.deleteOverlaysCluster(params);
  }
  public async showLayer(params: ILayerConfig) {
    console.log(params);
    let toggleOther = params.toggleOther === true;
    let labels: string[] = params.label
      ? params.label instanceof Array
        ? (params.label as string[]) || []
        : [params.label]
      : [];
    if (labels.length == 0) {
      return;
    }
    this.view.map.allLayers.forEach((baselayer: any) => {
      if (labels.indexOf(baselayer.label) > -1) {
        if (!baselayer.visible) {
          baselayer.visible = true;
        }
      } else {
        //其余的图层
        if (
          toggleOther &&
          (baselayer.type == "feature" || baselayer.type == "map-image")
        ) {
          baselayer.visible = false;
        }
      }
    });
  }
  public async hideLayer(params: ILayerConfig) {
    console.log(params);
    let toggleOther = params.toggleOther === true;
    let labels: string[] = params.label
      ? params.label instanceof Array
        ? (params.label as string[]) || []
        : [params.label]
      : [];
    if (labels.length == 0) {
      return;
    }
    this.view.map.allLayers.forEach((baselayer: any) => {
      if (labels.indexOf(baselayer.label) > -1) {
        if (baselayer.visible) {
          baselayer.visible = false;
        }
      } else {
        //其余的非切片图层
        if (
          toggleOther &&
          (baselayer.type == "feature" || baselayer.type == "map-image")
        ) {
          baselayer.visible = true;
        }
      }
    });
  }
  public toggleLayerByYear(year: string) {
    let showlabels: string[] = [];
    this.view.map.allLayers.forEach((baselayer: any) => {
      if (
        (baselayer.type == "feature" || baselayer.type == "map-image") &&
        baselayer.visible
      ) {
        if (baselayer.label) {
          showlabels.push(baselayer.label);
        }
      }
    });
    showlabels = showlabels.map((label: string) => {
      label = label
        .replace("2025", year)
        .replace("2024", year)
        .replace("2023", year)
        .replace("2022", year)
        .replace("2021", year)
        .replace("2020", year)
        .replace("2019", year)
        .replace("2018", year);
      return label;
    });
    console.log("change to year " + year, showlabels);

    this.showLayer({ label: showlabels, toggleOther: true });
  }

  public async setMapCenter(params: IPointGeometry) {
    let x = params.x;
    let y = params.y;

    if (!isNaN(x) && !isNaN(y)) {
      await this.view.goTo({
        center: [x, y],
      });
    }
  }

  public setMapViewpoint(viewpoint: __esri.Viewpoint) {
    this.view.viewpoint = viewpoint;
  }

  public async setMapLevel(params: IMapLevel): Promise<void> {
    const animate = params.animate === true;
    const level = params.level;
    const factor = params.factor;

    if (level) {
      if (animate) {
        await this.view.goTo({ zoom: level });
      } else {
        this.view.zoom = level;
      }
    } else if (factor) {
      if (animate) {
        await this.view.goTo({ zoom: this.view.zoom + factor });
      }
      this.view.zoom += factor;
    }
  }

  public async setMapCamera(params: ICamera) {
    await this.view.goTo(params, params);
  }
  public async setMapCenterAndLevel(params: ICenterLevel) {
    let x = params.x;
    let y = params.y;
    let level: number = params.level || this.view.zoom;

    if (!isNaN(x) && !isNaN(y) && !isNaN(level) && level >= 0) {
      await this.view.goTo({
        zoom: level,
        center: [x, y],
      });
    }
  }

  public async setMapScaleFactor(factor: number) {
    const scale = this.view.scale;
    await this.view.goTo({ scale: scale * factor });
  }

  public mapToScreen(x: number, y: number): __esri.ScreenPoint {
    const point = new this.Point({ x, y });
    return this.view.toScreen(point);
  }

  public async showJurisdiction() {}
  public async hideJurisdiction() {}
  public async findFeature(params: IFindParameter): Promise<IResult> {
    // const overlay = OverlayArcgis3D.getInstance(this.view);
    // return await overlay.findFeature(params);
    const find = FindFeature.getInstance(this.view);
    return await find.findLayerFeature(params);
  }
  private async highlightFeature(geometry?: any) {
    const findfeature = FindFeature.getInstance(this.view);
    findfeature.startHighlightOverlays(geometry);
  }
  public async showDistrictMask(param: IDistrictParameter) {}
  public async hideDistrictMask() {}
  public async showRoad() {}
  public async hideRoad() {}
  public async showStreet() {}
  public async hideStreet() {}
  public async locateStreet(param: IStreetParameter) {}
  public setMapStyle(param: string) {}

  public async routeSearch(params: IRouteParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public clearRouteSearch() {}

  public showRoutePoint(params: any) {}
  public clearRoutePoint() {}

  public async addDrawLayer(params: any): Promise<IResult> {
    const drawlayer = DrawLayer.getInstance(this.view);
    return await drawlayer.addDrawLayer(params);
  }
  public clearDrawLayer(params: any) {
    const drawlayer = DrawLayer.getInstance(this.view);
    drawlayer.clearDrawLayer(params);
  }
  public showMigrateChart(params: any) {
    const chart = MigrateChart.getInstance(this.view);
    chart.showMigrateChart(params);
  }
  public hideMigrateChart() {
    const chart = MigrateChart.getInstance(this.view);
    chart.hideMigrateChart();
  }
  public showBarChart(params: any) {
    const chart = Bar3DChart.getInstance(this.view);
    chart.showBarChart(params);
  }
  public hideBarChart() {
    const chart = Bar3DChart.getInstance(this.view);
    chart.hideBarChart();
  }
  public addHeatImage(params: IHeatImageParameter) {
    const heatmap2 = HeatImage3D.getInstance(this.view);
    return heatmap2.startup(params);
  }
  public deleteHeatImage() {}
  public async startGeometrySearch(
    params: IGeometrySearchParameter
  ): Promise<IResult> {
    let geometrySearch = GeometrySearch.getInstance(this.view);
    return await geometrySearch.startGeometrySearch(params);
  }
  public clearGeometrySearch() {
    let geometrySearch = GeometrySearch.getInstance(this.view);
    geometrySearch.clearGeometrySearch();
  }
  public async showDgene(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public hideDgene() {}
  public async addDgeneFusion(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async restoreDegeneFsion(): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public showCustomTip(params: ICustomTip) {
    let className: string = "custom-popup";
    if (params == undefined || (params && params.clear !== false)) {
      ToolTip.clear(this.view, undefined, className);
    }
    if (params && params.geometry) {
      params.prop.className = className;
      let ctip = new ToolTip(this.view, params.prop, params.geometry);
    }
  }
  public closePopup() {
    this.view.popup.close();
  }
  public async showPopup(params: IPopUpTemplate) {
    if (!this.clickPopup) {
      return;
    }
    let popup = this.clickPopup.popup;
    let graphic = this.clickPopup.graphic;
    let mp = this.clickPopup.mapPoint;
    let attrs = Utils.copyObject(graphic.attributes);

    for (let field in attrs) {
      let fieldArr: string[] = field.toString().split(".");
      let newfield = fieldArr.pop() as string;
      if (!attrs.hasOwnProperty(newfield)) {
        attrs[newfield] =
          attrs[field] !== undefined && attrs[field] !== null
            ? attrs[field].toString().replace("Null", "")
            : "";
      }
    }
    for (let str in params.fields) {
      //if (!attrs.hasOwnProperty(str)) {
      attrs[str] = params.fields[str];
      //}
    }

    if (popup) {
      this.view.popup.open({
        title: popup.title,
        content: this.getContent(attrs, popup.content),
        location: mp,
      });
    }
  }
  public showDgeneOutPoint(params: any) {}
  public changeDgeneOut() {}

  public async initializeRouteSelect(params: ISelectRouteParam) {}
  public async showSelectedRoute(params: ISelectRouteResult) {}
  public async playSelectedRoute(speed: number) {}
  public stopPlaySelectedRoute() {}
  public async routeHitArea(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: "" };
  }
  public async areaHitRoute(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: "" };
  }

  public async startDrawOverlays(params: IDrawOverlays): Promise<void> {}
  public async stopDrawOverlays(): Promise<void> {}
  public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {}
  public async getDrawOverlays(): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async startLayerSearch(
    params: IGeometrySearchParameter
  ): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async startLayerDefinition(
    params: IDefinitionParameter
  ): Promise<void> {}

  public async startTrackPlay(params: ITrackParameter): Promise<void> {
    const trackplay = TrackPlay3D.getInstance(this.view);
    return await trackplay.startTrackPlay(params);
  }
  public async getRegionOverlays(params: IOverlayParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }

  public async connectSumoSimulation(
    params: ISumoConnectInfo
  ): Promise<IResult> {
    const similationController = SimulationController.getInstance(this.view);
    return similationController.connectSumoSimulation(params);
  }

  public disconnectSumoSimulation() {
    const similationController = SimulationController.getInstance(this.view);
    similationController.disconnectSumoSimulation();
  }

  public async connectRealTimeSimulation(
    params: ISumoConnectInfo
  ): Promise<IResult> {
    const similationController = SimulationController.getInstance(this.view);
    return similationController.connectRealTimeSimulation(params);
  }

  public disconnectRealTimeSimulation() {
    const similationController = SimulationController.getInstance(this.view);
    similationController.disconnectRealTimeSimulation();
  }

  public async toggleWatchMapFocus(params: { types: string[] }) {
    const mapCenterCheck = MapCenterCheck.getInstance(this.view);
    await mapCenterCheck.toggleWatchMapFocus(params);
  }

  public async startWatchMapFocus() {
    const mapCenterCheck = MapCenterCheck.getInstance(this.view);
    mapCenterCheck.mapFocused = this.mapFocused;
    await mapCenterCheck.startWatchMapFocus();
  }

  public stopWatchMapFocus() {
    const mapCenterCheck = MapCenterCheck.getInstance(this.view);
    mapCenterCheck.stopWatchMapFocus();
  }

  public async setMapFocus(focusInfo: {
    type: string;
    id: string;
    scaleFactor?: number;
    highlightOpt?: any;
  }): Promise<IResult> {
    const mapCenterCheck = MapCenterCheck.getInstance(this.view);
    return mapCenterCheck.setMapFocus(focusInfo);
  }

  public startWatchMapCenter() {
    const mapCenterCheck = MapCenterCheck.getInstance(this.view);
    mapCenterCheck.mapInteractive = this.mapInteractive;
    mapCenterCheck.startWatchMapCenter();
  }

  public stopWatchMapCenter() {
    const mapCenterCheck = MapCenterCheck.getInstance(this.view);
    mapCenterCheck.stopWatchMapCenter();
  }

  public async addMiniMapPoints(params: IOverlayParameter): Promise<IResult> {
    if (!params.type) {
      params.type = "minipoint";
    }
    if (params.miniMapView) {
      if (params.crossIds) {
        let overlays: any[] = [];
        checkPoints.forEach((checkPoint, index) => {
          if (
            checkPoint.type === "cross" &&
            params.crossIds &&
            params.crossIds.indexOf(checkPoint.id) > -1
          ) {
            overlays.push({
              id: checkPoint.id,
              geometry: {
                x: checkPoint.position[0],
                y: checkPoint.position[1],
              },
              fields: { id: checkPoint.id },
            });
          }
        });
        params.overlays = overlays;
      }
      const overlay = OverlayArcgis2D.getInstance(params.miniMapView);
      overlay.deleteOverlays({ types: [params.type] });
      return overlay.addOverlays(params);
    }
    return { status: 0, message: "" };
  }

  public async initPassageWall(params: { roadUrl: string }): Promise<IResult> {
    const passWall = PassagewayWall.getInstance(this.view);
    return await passWall.initPassageWall(params);
  }

  public async addPassageWall(params: IPassagewaysParam) {
    const passWall = PassagewayWall.getInstance(this.view);
    await passWall.addPassageWall(params);
  }

  public async deletePassageWall() {
    const passWall = PassagewayWall.getInstance(this.view);
    await passWall.deletePassageWall();
  }

  public async addAnimatePoints(params: IOverlayParameter): Promise<IResult> {
    const aniamteType = params?.animateType ?? "bubble";
    if (!params.type) {
      params.type = "alarm";
    }
    if (params.crossIds) {
      let overlays: any[] = [];
      checkPoints.forEach((checkPoint, index) => {
        if (
          checkPoint.type === "cross" &&
          params.crossIds &&
          params.crossIds.indexOf(checkPoint.id) > -1
        ) {
          overlays.push({
            id: checkPoint.id,
            geometry: {
              x: checkPoint.position[0],
              y: checkPoint.position[1],
            },
            fields: { id: checkPoint.id, type: "alarm" },
          });
        }
      });
      params.overlays = overlays;
    }
    if (params.showInMiniMap && params.miniMapView) {
      switch (aniamteType) {
        case "ripple":
        case "bubble": {
          const miniBubbleLayer = BubbleLayer.getInstance(params.miniMapView);
          await miniBubbleLayer.initialize({
            minSize: 1,
            maxSize: 10,
            speed: 0.3,
          });
          miniBubbleLayer.addPoints(params);
          break;
        }
        // case "diamond": {
        //   const miniDiamondLayer = DiamondLayer.getInstance(params.miniMapView);
        //   await miniDiamondLayer.initialize({
        //     symbolWidth: 200,
        //     symbolHeight: 600
        //   });
        //   miniDiamondLayer.addPoints(params);
        //   break;
        // }
      }
    }

    switch (aniamteType) {
      case "bubble": {
        const bubbleLayer = BubbleLayer.getInstance(this.view);
        await bubbleLayer.initialize();
        bubbleLayer.addPoints(params);
        break;
      }

      case "diamond": {
        const diamondLayer = DiamondLayer.getInstance(this.view);
        await diamondLayer.initialize();
        diamondLayer.addPoints(params);
        break;
      }

      case "ripple": {
        const rippleLayer = RippleLayer.getInstance(this.view);
        await rippleLayer.addPoints(params);
        break;
      }

      case "wall": {
        const wallLayer = WallLayer.getInstance(this.view);
        await wallLayer.addWalls(params);
        break;
      }
    }

    return { status: 0, message: "" };
  }

  public async deleteAnimatePoints(params?: IOverlayDelete): Promise<IResult> {
    const aniamteType = params?.animateType ?? "bubble";

    if (params?.miniMapView) {
      switch (aniamteType) {
        case "bubble": {
          const miniBubbleLayer = BubbleLayer.getInstance(params.miniMapView);
          miniBubbleLayer.removeAll();
        }

        // case "diamond": {
        //   const miniDiamondLayer = DiamondLayer.getInstance(params.miniMapView);
        //   miniDiamondLayer.removeAll();
        // }
      }
    }

    switch (aniamteType) {
      case "bubble": {
        const bubbleLayer = BubbleLayer.getInstance(this.view);
        bubbleLayer.removeAll();
      }

      case "diamond": {
        const diamondLayer = DiamondLayer.getInstance(this.view);
        diamondLayer.removeAll();
      }
    }

    return { status: 0, message: "" };
  }

  public async startSignalPhase(params: ISignalPhaseInfo): Promise<IResult> {
    const signalPhaseController = SignalPhaseController.getInstance(this.view);
    signalPhaseController.requestNextSignalPhase = this.requestNextSignalPhase;
    // signalPhaseController.phaseChanged = this.phaseChanged;
    return signalPhaseController.setSignalPhase(params);
  }

  public async startDrawCrossRegion(params?: {
    tool?: string;
  }): Promise<IResult> {
    const crossRegion = CrossRegion.getInstance(this.view);
    return crossRegion.startDrawCrossRegion(params);
  }

  public async stopDrawCrossRegion() {
    const crossRegion = CrossRegion.getInstance(this.view);
    return crossRegion.stopDrawCrossRegion();
  }

  public startDeleteCrossRegion(): Promise<IResult> {
    const crossRegion = CrossRegion.getInstance(this.view);
    return crossRegion.startDeleteCrossRegion();
  }

  public stopDeleteCrossRegion() {
    const crossRegion = CrossRegion.getInstance(this.view);
    crossRegion.stopDeleteCrossRegion();
  }

  public showCrossRegions(params: { regions: Array<ICrossRegionInfo> }) {
    const crossRegion = CrossRegion.getInstance(this.view);
    crossRegion.showCrossRegions(params);
  }

  public hideCrossRegions() {
    const crossRegion = CrossRegion.getInstance(this.view);
    crossRegion.hideCrossRegions();
  }

  public toggleBuildingLayer(visible: boolean) {
    this.view.map.layers.forEach((layer) => {
      if (layer.title.includes("建筑")) {
        layer.visible = visible;
      }
    });
  }
  public toggleWidget(params: string[]) {}

  private removeCrossGraphic() {
    const removeGraphics = this.view.graphics.filter(
      (graphic) =>
        graphic.attributes && graphic.attributes["type"] === "cross-scene"
    );
    this.view.graphics.removeMany(removeGraphics);
  }

  public queryCrossInView(params: ICrossInView): IResult {
    const crossInfos: Array<{
      id: string;
      name: string;
      position: number[];
    }> = [];
    this.removeCrossGraphic();

    // 获取当前camera视角在地图上的投影，是一个梯形
    const { width, height } = this.view;
    let leftTopPoint = this.view.toMap({ x: 0, y: 0 });
    let leftBottomPoint = this.view.toMap({ x: 0, y: height });
    let rightBottomPoint = this.view.toMap({
      x: width,
      y: height,
    });
    let rightTopPoint = this.view.toMap({ x: width, y: 0 });
    if (leftBottomPoint.spatialReference.isWebMercator) {
      leftTopPoint = this.webMercatorUtils.webMercatorToGeographic(
        leftTopPoint
      ) as __esri.Point;
      leftBottomPoint = this.webMercatorUtils.webMercatorToGeographic(
        leftBottomPoint
      ) as __esri.Point;
      rightBottomPoint = this.webMercatorUtils.webMercatorToGeographic(
        rightBottomPoint
      ) as __esri.Point;
      rightTopPoint = this.webMercatorUtils.webMercatorToGeographic(
        rightTopPoint
      ) as __esri.Point;
    }
    const edgePolygon: __esri.Polygon = {
      type: "polygon",
      rings: [
        [
          [leftTopPoint.x, leftTopPoint.y],
          [rightTopPoint.x, rightTopPoint.y],
          [rightBottomPoint.x, rightBottomPoint.y],
          [leftBottomPoint.x, leftBottomPoint.y],
          [leftTopPoint.x, leftTopPoint.y],
        ],
      ],
      spatialReference: { wkid: 4326 },
    } as any;

    checkPoints.forEach((checkPoint) => {
      if (checkPoint.type === "cross") {
        const crossPoint = new this.Point({
          x: checkPoint.position[0],
          y: checkPoint.position[1],
        });
        if (this.geometryEngine.within(crossPoint, edgePolygon)) {
          crossInfos.push({
            id: checkPoint.id,
            name: checkPoint.name,
            position: checkPoint.position,
          });
          if (params?.showPoint) {
            const crossGraphic = new this.Graphic({
              geometry: crossPoint,
              symbol: {
                type: "point-3d",
                symbolLayers: [
                  {
                    type: "icon",
                    size: "42px",
                    resource: {
                      href: "./icon/discordant-cross.png",
                    },
                  },
                ],
              } as any,
              attributes: {
                type: "cross-scene",
                id: checkPoint.id,
              },
            });
            this.view.graphics.add(crossGraphic);
          }
        }
      }
    });

    return { status: 0, message: "", result: crossInfos };
  }

  public async setCrossCamera(params: ICrossCamera) {
    const cam = CameraPosition.getInstance(this.view);
    cam.crossInfoPanelInfos = this.crossInfoPanelInfos;
    cam.requestNextSignalPhase = this.requestNextSignalPhase;
    cam.phaseChanged = this.phaseChanged;
    await cam.setCrossCamera(params);
  }

  public clearCrossCamera() {
    let cam = CameraPosition.getInstance(this.view);
    cam.clearCrossCamera();
  }

  public initializeLaneSignalPhase(crossId: string) {}

  public startLaneSignalPhase(laneSignalPhaseInfos: ILaneSignalPhaseInfo[]) {
    const signalPhaseController = SignalPhaseController2D.getInstance(
      this.view
    );
    signalPhaseController.startLaneSignalPhase(laneSignalPhaseInfos);
  }

  public stopLaneSignalPhase(crossId: string) {
    const signalPhaseController = SignalPhaseController2D.getInstance(
      this.view
    );
    signalPhaseController.stopLaneSignalPhase(crossId);
  }

  public stopAllLaneSignalPhase() {
    const signalPhaseController = SignalPhaseController2D.getInstance(
      this.view
    );
    signalPhaseController.stopAllLaneSignalPhase();
  }

  public async selectLane_initialize(): Promise<void> {
    const selectLane = SelectLane.getInstance(this.view);
    await selectLane.initialize();
  }

  public selectLane_getResult(): IResult {
    const selectLane = SelectLane.getInstance(this.view);
    return selectLane.getResult();
  }

  public selectLane_showLanes(params: IShowSelectedLaneParam[]): void {
    const selectLane = SelectLane.getInstance(this.view);
    selectLane.showSelectedLanes(params);
  }

  public async addComponentOverlay(
    params: IComponentOverlayParam
  ): Promise<IResult> {
    const componentOverlay = ComponentOverlay.getInstance(this.view);
    return await componentOverlay.addComponentOverlay(params);
  }

  public deleteComponentOverlay(params?: IOverlayDelete): IResult {
    const componentOverlay = ComponentOverlay.getInstance(this.view);
    return componentOverlay.deleteComponentOverlay(params);
  }

  public async dynamicLayer_initialize(configFile: string) {
    const dynamicLayer = DynamicIssuesect.getInstance(this.view);
    await dynamicLayer.initialize(configFile);
  }

  public async dynamicLayer_show(
    params: IDynamicLayerDataParams
  ): Promise<void> {
    const dynamicLayer = DynamicIssuesect.getInstance(this.view);
    dynamicLayer.showDynamicRendererLayer(params);
  }

  public dynamicLayer_hide(params: IDynamicLayerDataParams): void {
    const dynamicLayer = DynamicIssuesect.getInstance(this.view);
    dynamicLayer.hideDynamicRendererLayer(params);
  }
}
